import * as gzBkImg from './bk-img.directive';

export default angular.module('gazelle.components.printosImages.bkImg', [
  'rhino.core',
])
  .directive(gzBkImg.name, gzBkImg.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/printos-images/bk-img/bk-img.module.js